<div class="video-play-btn position-absolute" *ngIf="isVideo"></div>
